
<div class="dialog-content input-company-dialog">
  <!--btn:關閉按鈕-->
  <button mat-button (click)="close()" class="dialog-close-btn">
    <img src="assets/img/i-close.svg" alt="" />
  </button>

  <!--title 標題-->
  <h1 class="dialog-title">請輸入企業代碼</h1>

  <!--dialog 內容-->
  <div mat-dialog-content class="dialog-body">
    <div class="input-block">
      <input
        type="text"
        class="company-input"
        appCompanyCodeOnly
        placeholder="請輸入企業代碼"
        maxlength="10"
        [class.input-error]="hasError"
        [formControl]="enterpriseCodeControl"
        (input)="onInputChange($event)"
      />
      @if (hasError) {
        <div class="input-error-msg">
          {{ getCompanyCodeErrorMessage() }}
        </div>
      }
    </div>

    <button 
      mat-button 
      class="btn-fill-primary btn-size-l confirm-btn full-width-btn"
      [disabled]="isButtonDisabled"
      (click)="onConfirm()"
    >
      開始預約
    </button>
  </div>
</div>

